import type { FC } from "react";
import styled from "styled-components";
import { ProfileItemContainer } from "../MmProfileItem/ProfileItem";
import { CollapseButton } from "./CollapseButton";
import { MenuContainer } from "./MenuContainer";
import { SidebarContainer } from "./SidebarContainer";
import { useSidebarState } from "./state";
import "@nectary/components/skeleton";
import "@nectary/components/skeleton-item";

const SCROLL_BAR_COLOR = "rgb(94, 94, 94) rgba(0, 0, 0, 0)";
const WEBKIT_SCROLL_BAR_COLOR = "rgb(94, 94, 94)";
const NavigationContainer = styled.div.attrs(() => useSidebarState())`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: hidden;
  overflow-x: hidden;
  padding: 12px 0 6px 0;
  background-color: var(--sinch-sys-color-container-main-default);
  height: 100%;
  max-height: 100vh;
  scrollbar-gutter: stable both-edges;
  scrollbar-color: ${SCROLL_BAR_COLOR};
  scrollbar-width: thin;

  ::-webkit-scrollbar {
    appearance: none;
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${WEBKIT_SCROLL_BAR_COLOR};
    border-radius: 3px;
  }

  :hover {
    overflow-y: scroll;
  }
`;

export const Sidebar: FC = ({ children }) => (
  <SidebarContainer>
    <MenuContainer>
      <NavigationContainer>{children}</NavigationContainer>
      <CollapseButton />
    </MenuContainer>
  </SidebarContainer>
);

export const SidebarScaffold: FC<{ skeleton?: boolean }> = ({ skeleton }) => (
  <SidebarContainer show={false}>
    <MenuContainer>
      {skeleton && (
        <div style={{ width: "100%", padding: "16px 16px 0px" }}>
          <sinch-skeleton>
            <sinch-skeleton-item />
            <sinch-skeleton-item />
            <sinch-skeleton-item />
            <sinch-skeleton-item />
            <sinch-skeleton-item />
          </sinch-skeleton>
        </div>
      )}
      <ProfileItemContainer style={{ padding: 16 }}>
        {skeleton && (
          <sinch-skeleton style={{ width: "100%" }}>
            <sinch-skeleton-item />
          </sinch-skeleton>
        )}
      </ProfileItemContainer>
    </MenuContainer>
  </SidebarContainer>
);
